import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useEffect, useMemo, useState, } from 'react';
import produce from 'immer';
export const DialectUiManagementContext = createContext(null);
export const DialectUiManagementProvider = ({ children }) => {
    const [ui, setUi] = useState({});
    const [navigation, setNavigation] = useState({});
    const register = useCallback((id) => setUi(produce((draft) => {
        var _a;
        draft[id] = (_a = draft[id]) !== null && _a !== void 0 ? _a : { open: false };
    })), []);
    const open = useCallback((id) => setUi(produce((draft) => {
        const window = draft[id];
        if (window) {
            window.open = true;
        }
    })), []);
    const close = useCallback((id) => setUi(produce((draft) => {
        const window = draft[id];
        if (window) {
            window.open = false;
        }
    })), []);
    // Extend for necessary configurations
    const configure = useCallback((id, config) => {
        setNavigation(produce((draft) => {
            if (!config) {
                draft[id] = null;
                return;
            }
            const { navigation } = config;
            // Also, this is not great probably in terms of immer usage
            draft[id] = { ...draft[id], ...navigation }; // FIXME: types...
        }));
    }, []);
    return (_jsx(DialectUiManagementContext.Provider, { value: { ui, navigation, register, open, close, configure }, children: children }));
};
export const useDialectUi = () => {
    const context = useContext(DialectUiManagementContext);
    if (!context) {
        throw new Error('useDialectUi must be used within an DialectUIManagementProvider');
    }
    return context;
};
export const useDialectUiId = (id) => {
    const { ui: uis, navigation: navigations, open: mainOpen, close: mainClose, register, configure: mainConfigure, } = useDialectUi();
    const ui = useMemo(() => uis[id], [uis, id]);
    const navigation = useMemo(() => navigations[id], [navigations, id]);
    const open = useCallback(() => mainOpen(id), [mainOpen, id]);
    const close = useCallback(() => mainClose(id), [mainClose, id]);
    const configure = useCallback((config) => mainConfigure(id, config), [mainConfigure, id]);
    useEffect(() => register(id), [register, id]);
    return { ui, navigation, open, close, configure };
};
//# sourceMappingURL=DialectUiManagementProvider.js.map